import { render, staticRenderFns } from "./WorkspaceSettingInfo.vue?vue&type=template&id=28dddaa8"
import script from "./WorkspaceSettingInfo.vue?vue&type=script&lang=js"
export * from "./WorkspaceSettingInfo.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceSettingInfo.vue?vue&type=style&index=0&id=28dddaa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports